// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * The state of a whole sequence run. APPEND-ONLY: the ordinal is the wire value.
 */
export enum SequenceRunStatus {
  /**
   * Steps remain.
   */
  Running = 0,

  /**
   * Every step passed.
   */
  Completed = 1,

  /**
   * A step after the release failed or timed out; always-run steps were still
   * executed.
   */
  Failed = 2,

  /**
   * A step before the release failed under the DROP policy: the command was
   * not sent.
   */
  Withheld = 3,

  /**
   * The preconditions did not hold: the command passed through without the
   * sequence.
   */
  Skipped = 4,

  /**
   * A step before the release failed under the RELEASE policy: the command was
   * sent anyway.
   */
  Released = 5,
}
